<!-- Social Login Buttons  -->
<div class="ui grid">
  <div class="three column row">
    <div class="column">
      <a
        class="ui medium basic icon button"
        [ngClass]="{ 'elastic loading': isSubmitted && google === loginBy }"
        (click)="loginInWithGoogle()"
      >
        <i class="icon google"></i>
        Google
      </a>
    </div>
    <div class="column">
      <a
        class="ui medium basic icon button"
        [ngClass]="{ 'elastic loading': isSubmitted && twitter === loginBy }"
        (click)="loginInWithTwitter()"
      >
        <i class="icon twitter"></i>
        Twitter
      </a>
    </div>
    <div class="column">
      <a
        class="ui medium basic icon button"
        [ngClass]="{ 'elastic loading': isSubmitted && facebook === loginBy }"
        (click)="loginInWithFaceBook()"
      >
        <i class="icon facebook"></i>
        Facebook
      </a>
    </div>
  </div>
</div>
<!-- Social Login Ends  -->
